import classnames from 'classnames';
import { route2 } from '@/utils/data';

import PageLayout from '@/components/organisms/PageLayout';
import Title from '@/components/atoms/Title';
import ButtonGameState from '@/components/atoms/ButtonGameState';

import styles from './index.module.css';

export interface LayoutAboutDestinyProp {
    className?: string;
    loading?: boolean;
    active?: boolean;
}

const LayoutAboutDestiny: React.FC<LayoutAboutDestinyProp> = ({ className, loading, active }) => (
    <PageLayout loading={loading} active={active}>
        <div className={classnames(styles.layoutAboutLove, className)}>
            <Title className={styles.title}>{route2.title}</Title>
            <section className={styles.intro}>{route2.fullContent}</section>
            <div className={styles.itemWrapper}>
                {route2.infos.map(({ label, value, fullContent, hideOnDetailView }) => {
                    if (hideOnDetailView) return null;

                    return (
                        <div className={styles.item}>
                            <div className={styles.name}>{label}</div>
                            <div className={classnames(styles.value)}>{fullContent || value}</div>
                        </div>
                    );
                })}
            </div>
            <ButtonGameState className={styles.btn} status={route2.status} link={route2.link} />
        </div>
    </PageLayout>
);

export default LayoutAboutDestiny;
